import { ICrewManagerAgent } from "@kuika/kuika-cl-model";
import { Handle, NodeProps, Position } from "reactflow";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";

export interface IAiAgentManagerNodeData {
  managerAgent?: ICrewManagerAgent;
  sourceHandleId: string;
  onAddAgent?: () => void;
  sourceHandles?: Array<{
    id: string;
    position: "left" | "right" | "top" | "bottom";
    leftPercent: number;
    topPercent: number;
  }>;
}

export default function AIAgentManagerNode({ data }: NodeProps<IAiAgentManagerNodeData>) {
  const handles = data.sourceHandles?.length ? data.sourceHandles : [];

  return (
    <div className="react-flow__node-manager__container">
      <div className="react-flow__node-manager__header">
        <KuikaSvg type="datasource-icons" name="brain" width={24} height={24} color="var(--orange-8)" />
        <span className="react-flow__node-manager__title">Manager</span>
      </div>
      {/* {typeof data.onAddAgent === "function" && (
        <button
          type="button"
          className="react-flow__node-manager__add-button"
          onClick={(e) => {
            e.stopPropagation();
            data.onAddAgent?.();
          }}
        >
          <KuikaSvg type="common" name="plus" width={14} height={14} color="var(--dark-1)" />
        </button>
      )} */}
      {handles.map((handle) => {
        const position =
          handle.position === "left"
            ? Position.Left
            : handle.position === "top"
              ? Position.Top
              : handle.position === "bottom"
                ? Position.Bottom
                : Position.Right;

        return (
          <Handle
            key={handle.id}
            id={handle.id}
            type="source"
            position={position}
            style={{
              left: `${handle.leftPercent}%`,
              top: `${handle.topPercent}%`,
              transform: "translate(-50%, -50%)"
            }}
          />
        );
      })}
    </div>
  );
}
